module.exports = __webpack_public_path__ + "media/images/athletes/1585-894cd096e6a2e2984723ee9af9d4b25b.png";